import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupSurgical(): void {
  applicationModuleRegistry.register({
    entry: 'SURGICAL#9139',
    id: 'SURGICAL#9139',
    name: 'module.surgical',
    route: `${ApplicationRoute.SURGICAL}${ApplicationRoute.SURGICAL_OPTIONS}`
  });
}
